import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {GeneralService} from '../../services/general.service';

@Component({
    selector: 'existing-order-lines',
    templateUrl: './existing-order-lines.component.html',
    styleUrls: ['./existing-order-lines.component.scss'],
})
export class ExistingOrderLinesComponent implements OnInit {

    @Input() document: DocumentModel;
    @Input() ordersList: DocumentModel[];
    @Input() contractList: DocumentModel[];
    display = true;
    orderLines: DetaillineDTOModel[];
    contractLines: DetaillineDTOModel[];

    constructor(private generalService: GeneralService) {
    }

    ngOnInit() {
        console.log('orderList:', this.ordersList);
        console.log('contractList:', this.contractList);
        this.orderLines = this.groupDetailLines(this.ordersList);
        this.contractLines = this.groupDetailLines(this.contractList);
        // this.filterOrderLines();
        this.orderLines.sort((a, b) => (a.pdesc > b.pdesc) ? 1 : -1);
        console.log(this.findQty('1096'));
        console.log(this.contractLines[0].pdesc);
    }

    groupDetailLines(docList: DocumentModel[]) {
        const tempList = [];
        // this.document.existingOrderLines = {};
        // this.document.existingOrderLines.doc = [];
        for (const doc of docList) {
            console.log(doc.documentType);
            for (const line of doc.detailLines) {
                const index = this.isDetailLineAdded(line, tempList);
                // if (doc.documentType === 5) {
                //     this.document.existingOrderLines.doc.push(line);
                // }
                if (index >= 0) {
                    console.log(tempList[index]);
                    tempList[index].qty += line.qty;
                } else {
                    tempList.push(line);
                }
            }
        }
        return tempList;
    }

    isDetailLineAdded(line: DetaillineDTOModel, lineList: DetaillineDTOModel[]) {
        for (let i = 0; i < lineList.length; i++) {
            if (lineList[i].pdesc === line.pdesc) {
                return i;
            }
        }
        return -1;
    }

    findQty(pdesc: string) {
        let tempLine = 0;
        this.contractLines.find(elem => {
            if (elem.pdesc === pdesc) {
                tempLine = elem.qty;
            }
            return elem.pdesc === pdesc;
        });
        return tempLine;
    }

    addDetailLine(line: DetaillineDTOModel) {
        if (this.isDetailLineAdded(line, this.document.detailLines) >= 0) {
            this.generalService.createToast('Item already added');
        } else {
            const tempLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
            tempLine.overrideDescriptionNote = line.description;
            console.log(tempLine);
            this.document.detailLines.push(tempLine);
            this.generalService.createToast('Item added to the document');
        }
    }

    filterOrderLines() {
        for (const orderLine of this.orderLines) {
            const index = this.isDetailLineAdded(orderLine, this.document.detailLines);
            if (index >= 0) {
                this.orderLines.splice(index, 1);
            }
        }
    }
}
